import React, { useState, useEffect } from "react"
import { navigate } from "gatsby"
import NewBusinessIcon from "../../images/business/new-business.svg"
import TitleText from "./TitleText"
import axios from "axios"
import BusinessTitleCard from "./BusinessCardTitle"
import ProceedButton from "./ProceedButton"
import Info from "./Info"
import { useQuery } from "../../hooks/useQuery"

const TinApplication = () => {
  const [businessfees, setBusinessFee] = useState("25,000")
  const [loading, setLoading] = useState(false)
  const queryParams = useQuery("token")
  const gotoNext = () => {
    if (queryParams) {
      localStorage.setItem("mobile_token", queryParams)
      navigate("/business-support/mobile-business-reg/start", {
        state: {
          service: "New Business Registration",
          path: "/business-support/mobile-business-reg/start",
        },
      })
    } else {
      navigate("/business-support/verify", {
        state: {
          service: "New Business Registration",
          path: "/business-support/mobile-business-reg/start",
        },
      })
    }
  }
  useEffect(() => {
    const storedData = localStorage.getItem("supportFees")

    if (storedData) {
      // Convert the JSON string back to an object
      const parsedData = JSON.parse(storedData)
      setBusinessFee(parsedData)
    } else {
      const fetchSupportRates = async () => {
        try {
          setLoading(true)
          const res = await axios.get(
            `${process.env.GATSBY_SPARKLE_LOCAL_BASE_URL}/api/v1/business/support-rates`
          )

          setBusinessFee(res.data.data.fees)

          localStorage.setItem(
            "supportFees",
            JSON.stringify(res.data.data.fees)
          )
        } catch (error) {
          console.error("Failed to fetch support rates:", error)
        } finally {
          setLoading(false)
        }
      }

      fetchSupportRates()
    }
  }, [])
  return (
    <div className="row justify-content-center">
      <div className="col-lg-8">
        <TitleText />
        <BusinessTitleCard
          icon={NewBusinessIcon}
          title="Register a new business"
          subtitle="Officially register your business, get CAC and a tax identification number."
        />
        <div className="business-suport-card p-lg-4 p-3 my-5">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <div className="intro">
              <div className="ml-lg-4">
                <ul className="list-styled ml-lg-5 pl-lg-5">
                  <li>Register your new business name.</li>
                  <li>
                    Submit 2-4 names for the business in order of preference
                  </li>
                  <li>
                    Profile your business by listing it’s purpose, type of
                    Business Name (Sole proprietorship or Partnership) etc.
                  </li>
                  <li>
                    This service cost{" "}
                    <span>₦{businessfees.businessName}.00</span> if you already
                    have a Sparkle Personal account.
                  </li>
                  <li>
                    Timeline: 15-18 working days after name approval and receipt
                    of complete required documents and information.
                  </li>
                </ul>
              </div>

              <ProceedButton text="Proceed" handleClick={gotoNext} />
              <Info />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default TinApplication
